module.exports = __webpack_public_path__ + "img/y15.5b17bb88.jpg";